import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  limit: 20,
  page: 1,
  total: 0,
  totalPages: 1,
};

export const productPaginateSlice = createSlice({
  name: "productPaginateSlice",
  initialState,
  reducers: {
    setProductPageLimit: (state, action) => {
      state.limit = action.payload;
    },
    setProductCurrentPage: (state, action) => {
      state.page = action.payload;
    },
    setProductTotalCount: (state, action) => {
      state.total = action.payload;
    },
    setProductTotalPages: (state, action) => {
      state.totalPages = action.payload;
    },
    resetProductPagination: (state, action) => {
      state.limit = 20;
      state.page = 1;
      state.total = 0;
      state.totalPages = 1;
    },
  },
});

export const {
  setProductPageLimit,
  setProductCurrentPage,
  setProductTotalCount,
  setProductTotalPages,
  resetProductPagination,
} = productPaginateSlice.actions;

export default productPaginateSlice.reducer;
